import { create } from 'zustand';
import type { VehicleId } from '../types/gcs/vehicle';

interface FollowedVehicle {
  gcsId: string;
  vehicleId: VehicleId;
}

interface FollowedVehicleStore {
  followedVehicle: FollowedVehicle | null;
  isAutoFollowEnabled: boolean;
  setFollowedVehicle: (followedVehicle: FollowedVehicle) => void;
  enableAutoFollow: () => void;
  disableAutoFollow: () => void;
}

export const useFollowedVehicleStore = create<FollowedVehicleStore>((set) => ({
  followedVehicle: null,
  isAutoFollowEnabled: false,
  setFollowedVehicle: (followedVehicle) => set({ followedVehicle }),
  enableAutoFollow: () => set({ isAutoFollowEnabled: true }),
  disableAutoFollow: () => set({ isAutoFollowEnabled: false, followedVehicle: null })
}));
